const moment = require('moment-timezone');

export const getColumnStructureForPDF = (formData) => {
  const formDataClone = [...formData];
  formDataClone.forEach((formData) => {
    formData.inputs.forEach((formInput) => {
      if (formInput.length === 2) {
        formInput.push(null);
      }
    });
  });
  return formDataClone;
};

export const submittedRangeQuery = (from, to) => {
  const parts = [];
  if (from) parts.push(`&submittedFrom=${encodeURIComponent(from)}`);
  if (to) parts.push(`&submittedTo=${encodeURIComponent(to)}`);
  return parts.join('');
};

export const formatApplicantDate = (date) => {
  var dateMomentObject, dateObject;
  const dateIsValid =
    moment(date).format('MM/DD/YYYY') === 'Invalid date' ? false : true;
  if (!dateIsValid) {
    dateMomentObject = moment(date, 'DD/MM/YYYY');
    dateObject = dateMomentObject.toDate();
  } else {
    dateObject = moment(date).toDate();
  }

  if (Object.prototype.toString.call(dateObject) === '[object Date]') {
    if (isNaN(dateObject.getTime())) {
      return date;
    } else {
      return dateObject.toString();
    }
  } else {
    return date;
  }
};
